// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__t56Ai","location":"Header_location__2kKw3"};